import React , {useState} from "react";
import "./Gallery.css"
import PersonalCard from './PersonalCard';
import ReadMoreMurray from "./McBrideText";
import ReadMoreNyrstar from "./NyrstarText"
import ReadMoreCatherine from "./CatherineText"
import ReadMoreEnrico from "./EnricoText"
import ReadMoreSarah from "./SarahText"

const Gallery = () => {

    const [openStates, setOpenStates] = useState(
        Array(7).fill(false) // Assuming you have 7 gallery items, adjust as needed
      );
    
      const handleItemClick = (index) => {
        // Create a copy of the openStates array
        const updatedStates = [...openStates];
        // Toggle the open state for the clicked item
        updatedStates[index] = !updatedStates[index];
        setOpenStates(updatedStates);
      };

  
   

    const mainTakeawaysMurray = [
        'different factors influence cadmium uptake',
        'phytoremediation has potential but is slow',
        'our bacterium could have broader uses'
      ];
    
      const mainTakeawaysSV = [
        'GFP Nanobody to verify surface expression',
        'artifical mucus system to check for adhesion',
        'the turnover of Mucus'
      ];
    
    const mainTakeawaysCath = [
        'low oral bioavailability of Cd',
        'in vivo studies as a next step',
        'possible re-evaluation of selection of commensal bacteria',
        'importance of addressing the administration of the bacteria'
      ];
    
      const mainTakeawaysEnrico = [
        'prevent horizontal gene transfer',
        'test the percentage of removed cadmium',
        'some patients with other pathologies might be excluded'
      ];

      const mainTakeawaysSarah = [
        'European pharmaceutical regulations',
        "test the probiotic's tolerance to acid and bile",
        "test the probiotic's ability to adhere to human intestinal cells",
        'shelf-life of the product',
        'integration in common foods'
      ];

      const mainTakeawaysNel = [
        'possible application in industry and communities',
        'importance of transparent communication and promotion of the probiotic',
        'possible future developments for the modularity of the product',
      ];

      const mainTakeawaysZinc = [
        'adaptability of our product to other contaminants',
        'clear plan for testing and clinical approval',
        'insights on safety in a big company',
      ];

    

    return(
    <div className="relative">
                     <hr class="divider"></hr>
                    <h4>Academia</h4>
                    <div className={`flex ihatemyself ${openStates[0] || openStates[1] ? "flex-col gap-5" : openStates[2] ? "flex-col-reverse gap-5" : ""}`}>
                            {openStates[0] ? (
                            <div className="relative"><PersonalCard
                                photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/murray.jpeg"
                                name="Professor Murray McBride"
                                introduction="Professor Murray Brian McBride from Cornell University discussed cadmium absorption in plants, 
                                its impact on the food chain and the remediation of cadmium's presence in the soil. "
                                mainTakeaways={mainTakeawaysMurray}
                                fulltext= { <ReadMoreMurray/>}
                                handleClose = {() => handleItemClick(0)}
                            /></div>
                            
                        ) : (
                            <img className="photo"
                                                src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/murray.jpeg"
                                                alt="Murray Mcbride" 
                                                onClick={() => handleItemClick(0)}/>
                        )}

                            {openStates[1] ? (
                            <div className="relative">
                           <PersonalCard
                           photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/svepfl.png"
                           name="EPFL professors and PhDs"
                           introduction="We are fortunate to have access to a diverse array of life sciences experts at EPFL. 
                           As a result, we reached out to several professors and PhDs, who generously provided us with a 
                           range of valuable insights"
                           mainTakeaways={mainTakeawaysSV}
                           fulltext="Following a conversation with Jeremy Wong, we employed GFP Nanobody 
                           to confirm surface expression. Subsequently, based on discussions with Sofya Mikhaleva, 
                           the decision was made to leverage her artificial mucus system to assess adhesion capabilities. 
                           Furthermore, Alexandre Persat emphasized the importance of factoring in the turnover rate of 
                           mucus. Establishing a stable colonization necessitates substantial growth efforts."
                           handleClose = {() => handleItemClick(1)}
                       /></div>
                        
                    
                        ) : (
                            <img className="photo" src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/svepfl.png" alt="svepfl" 
                            onClick={() => handleItemClick(1)}/>
                        )}

                            {openStates[2] ? (
                              <div className="relative">
                            <PersonalCard
                            photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/catherine-jumarie.png"
                            name="Professor Catherine Jumarie"
                            introduction="We reached out to Professor Catherine Jumarie to gain a deeper 
                            insight into her research concerning the impact of cadmium-contaminated foods on human 
                            health and to inquire about the viability of our project in her perspective."
                            mainTakeaways={mainTakeawaysCath}
                            fulltext= { <ReadMoreCatherine/>}
                            handleClose = {() => handleItemClick(2)}
                        /></div>
  
                        
                        ) : (
                            <img className="photo" src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/catherine-jumarie.png" alt="catherine" 
                            onClick={() => handleItemClick(2)}/>
                        )}


                    </div>
                    <hr class="divider"></hr>
            
                    <h4>Healthcare professionals </h4>
                    <div className={`flex ihatemyself ${openStates[3] ? "flex-col gap-5" : openStates[4] ? "flex-col-reverse gap-5" : ""}`}>
                            {openStates[3] ? (
                           <div className="relative">
                            <PersonalCard
                            photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/fiaccadori.png"
                            name="Dr. Enrico Fiaccadori"
                            introduction="Since 1981 Enrico Fiaccadori has worked in the Complex Structure of Clinical and Medical 
                            Immunology of the University Hospital of Parma and since 2018 in the Complex Structure of Nephrology, 
                            with the position of director. He is a full-time university professor in the disciplinary scientific 
                            sector Nephrology, and Director of the School of Specialization in Nephrology at the University of Parma. 
                            We contacted him to get his opinion about our probiotic and to ask if he had had any experience with cadmium 
                            intoxication in his career in Nephrology. "
                            mainTakeaways={mainTakeawaysEnrico}
                            fulltext= {<ReadMoreEnrico/>}
                            handleClose = {() => handleItemClick(3)}
                        /></div>
                        
                        ) : (
                            <img className="photo" src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/fiaccadori.png" alt="Fiaccadori" 
                            onClick={() => handleItemClick(3)}/>
                        )}

                            {openStates[4] ? (
                            <div className="relative">
                            <PersonalCard
                            photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/sarah.jpeg"
                            name="PharmaD- Sarah Naili"
                            introduction="Sarah Naili is a Regulatory Scientist for PharmaD we contacted her to have more 
                            more information about pharmaceuticals regulations to better organise the next steps
                            for our product"
                            mainTakeaways={mainTakeawaysSarah}
                            fulltext= {<ReadMoreSarah/>}
                            handleClose = {() => handleItemClick(4)}
                        /></div>
                    
                        ) : (
                        <img className="photo" src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/sarah.jpeg" alt="Sarah"
                        onClick={() => handleItemClick(4)} />
                        )}
                        </div>
                    <hr class="divider"></hr>

                    <h4>Industry</h4>
                   <div className={`flex ihatemyself ${openStates[5] ? "flex-col gap-5" : openStates[6] ? "flex-col-reverse gap-5" : ""}`}>
                            {openStates[5] ? (
                        
                            <div className="relative"><PersonalCard
                            photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/nyrstar.jpeg"
                            name="Nyrstar - Louis Nel"
                            introduction="We reached out to Nyrstar and engaged in a discussion with Louis Nel, 
                            who serves as the Global Head of Health and Safety. During our conversation, we addressed 
                            the concern of cadmium within the industrial sector and explored potential utilities of 
                            our probiotic solution within the industrial community."
                            mainTakeaways={mainTakeawaysNel}
                            fulltext= {<ReadMoreNyrstar/>}
                            handleClose = {() => handleItemClick(5)}
                        /></div>
                        
                        ) : (
                        <img className="photo" src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/nyrstar.jpeg" alt="Nyrstar" 
                        onClick={() => handleItemClick(5)}/>
                        )}
                        

                            {openStates[6] ? (
                            <div className="relative">
                            <PersonalCard
                            photourl="https://static.igem.wiki/teams/4888/wiki/humanpractices/minesphoto.jpg"
                            name="Zinc department of company"
                            introduction="We had a discussion with representatives of the Zinc department 
                            of a large natural resources company."
                            mainTakeaways={mainTakeawaysZinc}
                            fulltext="During our conversation, we introduced our project and explained
                            our participation in the iGEM competition. The conversation then turned to 
                            questions about the approval process for our product, which, due to its 
                            genetic modification, requires pharmaceutical approval in compliance with 
                            LBP regulations. There were also inquiries about our dosing methodology for the LBP.
                            During our dialogue, we discussed our metal binding construct, EC20, and this topic 
                            piqued their interest. They were keen to understand the adaptability of our product 
                            for addressing other contaminants and inquired about EC20's affinity for metals beyond 
                            cadmium. This discussion emphasized the importance of delineating a clear plan for 
                            testing and clinical approval.
                            Subsequently, we asked several questions to gain insight into the company’s safety 
                            practices and explore the potential integration of our product into their industry. 
                            Their interest for our project was evident as they readily shared details about their 
                            workplace environment and methods for monitoring heavy metal exposure. Their protocols 
                            include measuring atmospheric exposure, such as dust, and conducting biological testing 
                            for cadmium levels in urine and blood, assessing both acute and chronic exposure. Blood 
                            testing provides insight into recent exposure, whilst urine testing provides insight into 
                            lifetime exposure with speciation providing insight into dietary exposure allowing 
                            differentiation from possible occupational exposure. The predominant sources of contamination 
                            stem from ingestion and respiratory pathways, with ingestion being the most significant, 
                            underlining the importance of personal hygiene practices. To prevent exposure, they have 
                            implemented a range of controls including but not limited to; extraction ventilation, 
                            awareness training around personal hygiene, cleaning facilities including a “clean” 
                            and “dirty” side change house, biological and occupational hygiene monitoring, 
                            and personal protective equipment to minimise exposure.
                            Incorporating operations across multiple countries, the natural resource company 
                            adheres to local regulatory standards while consistently monitoring exposure levels 
                            among employees. They face the challenge of varying standards in different countries 
                            but maintain a global perspective on safe exposure levels, ensuring uniformity across 
                            their operations.
                            *Version approved by the company"
                            handleClose = {() => handleItemClick(6)}
                        />
                        </div>
                    
                        ) : (
                        <img className="photo" src = "https://static.igem.wiki/teams/4888/wiki/humanpractices/minesphoto.jpg" 
                        alt="Zinc department " 
                        onClick={() => handleItemClick(6)}/>
                        )}
                        </div>
                    <hr class="divider"></hr>
            

            </div>
    )
}

export default Gallery;